/* GB Ready-to-play kits v3 (2026-10-18). Every kid gets 1 Raven (own color) + the Raven Full Bundle Gear.
   Prices use live variant prices + the native blaster ladder (2 = 5% each, 3+ = 10% each, per-unit rounding down).
   One cart request; lines carry _gbbs, and kit lines of a price-tested product also carry _bos_exp for assigned
   visitors (Emi 2026-10-20). Delegated events, so kits re-rendered by the collection grid keep working. */
(function () {
  'use strict';
  if (window.__gbkKits) return;
  window.__gbkKits = true;

  var cache = typeof WeakMap === 'function' ? new WeakMap() : null;

  function num(value, fallback) {
    var parsed = Number(value);
    return isFinite(parsed) ? parsed : (fallback || 0);
  }

  function currencyStep(currency) {
    var digits = 2;
    try {
      digits = new Intl.NumberFormat('en', { style: 'currency', currency: currency }).resolvedOptions().maximumFractionDigits;
    } catch (error) {
      digits = 2;
    }
    return Math.max(1, Math.pow(10, Math.max(0, 2 - digits)));
  }

  function unitDiscount(cents, pct, step) {
    return Math.floor(cents * pct / 100 / step) * step;
  }

  function moneyFormatter(sample, currency) {
    var match = /^(\D*)1(\D?)23(?:4(\D)(\d+)|5)(\D*)$/.exec(String(sample || '').trim());
    if (!match) {
      return function (cents) {
        try {
          return new Intl.NumberFormat(document.documentElement.lang || 'en', { style: 'currency', currency: currency }).format(cents / 100);
        } catch (error) {
          return (cents / 100).toFixed(2);
        }
      };
    }
    var prefix = match[1], grouping = match[2] || '', decimal = match[3] || '', places = match[4] ? match[4].length : 0, suffix = match[5] || '';
    return function (cents) {
      var abs = Math.abs(num(cents, 0));
      var whole = places ? Math.floor(abs / 100) : Math.round(abs / 100);
      var fraction = places ? String(Math.round(abs) % 100).padStart(2, '0').slice(0, places) : '';
      return (cents < 0 ? '-' : '') + prefix + String(whole).replace(/\B(?=(\d{3})+(?!\d))/g, grouping) + (places ? decimal + fraction : '') + suffix;
    };
  }

  /* BOS:PRICE-TEST bestseller-plus5-2026-10 (Emi 2026-10-20: "Yes, +$5 in kits too"). Mirrors assets/gb-bundle-box.js
     (R3a / R8): a kit line whose product is in the test (BundleOSExp.forProduct) carries _bos_exp = "<experiment>:<arm>"
     only when the visitor has an assignment, and the kit shows the SAME variant price the Cart Transform charges
     (priceFor), with compare-at = ceil(price x live compare / live price) to the whole unit. No API or no assignment
     (bots, feed clicks, non-USD, unassigned): today's kit and today's request. The kit price nodes carry
     data-bos-price, so the embed's anti-flicker style hides them until the embed is ready (this deferred script
     renders first); kits the collection grid re-inserts are projected before paint. No tracking calls here. */
  var BOS_EXP_ID = 'bestseller-plus5-2026-10';
  function bosApi() { var a = window.BundleOSExp; return a && typeof a.assignment === 'function' ? a : null; }
  function bosArm(productId) {
    try {
      var api = bosApi();
      if (!api || !productId || !api.forProduct(productId)) return null;
      return api.assignment(BOS_EXP_ID) || null;
    } catch (e) { return null; }
  }
  function bosPrice(variantId) {
    var price = null;
    try { price = bosApi().priceFor(variantId); } catch (e) { price = null; }
    return typeof price === 'number' && isFinite(price) && price > 0 ? Math.round(price * 100) : null;
  }
  /* Projects byKey / info in place; returns { lines: { variantId: _bos_exp value }, projected } or null. */
  function bosKit(root, byKey, info) {
    var ravenArm = bosArm(root.getAttribute('data-bos-raven-product-id'));
    var gearArm = bosArm(root.getAttribute('data-bos-gear-product-id'));
    if (!ravenArm && !gearArm) return null;
    var out = { lines: {}, projected: false };
    Object.keys(byKey).forEach(function (k) {
      var c = byKey[k];
      if (!ravenArm || !c || !c.id) return;
      out.lines[c.id] = BOS_EXP_ID + ':' + ravenArm;
      var cents = bosPrice(c.id);
      if (cents === null) return;
      var v = c.v;
      if (c.p > 0 && c.v > c.p) v = Math.ceil(cents * c.v / c.p / 100) * 100;
      byKey[k] = Object.assign({}, c, { p: cents, v: v });
      out.projected = true;
    });
    if (gearArm && info.gearId) {
      out.lines[info.gearId] = BOS_EXP_ID + ':' + gearArm;
      var gearCents = bosPrice(info.gearId);
      if (gearCents !== null) { info.gearPrice = gearCents; out.projected = true; }
    }
    return out;
  }
  function bosWatch() {
    try {
      var api = bosApi();
      if (!api || !api.assignment(BOS_EXP_ID) || typeof MutationObserver !== 'function') return;
      new MutationObserver(function (records) {
        try {
          records.forEach(function (record) {
            [].forEach.call(record.addedNodes || [], function (node) {
              if (!node || node.nodeType !== 1) return;
              var roots = node.matches && node.matches('[data-gbk]') ? [node] : [].slice.call(node.querySelectorAll('[data-gbk]'));
              roots.forEach(function (root) {
                var info = setup(root);
                if (info.bos && info.bos.projected) render(root);
              });
            });
          });
        } catch (e) {}
      }).observe(document.documentElement, { childList: true, subtree: true });
    } catch (e) {}
  }
  bosWatch();
  /* BOS:END-PRICE-TEST */

  function setup(root) {
    var hit = cache && cache.get(root);
    if (hit) return hit;
    var colors = [];
    try {
      colors = JSON.parse((root.querySelector('[data-gbk-colors]') || {}).textContent || '[]');
    } catch (error) {
      colors = [];
    }
    var byKey = {};
    colors.forEach(function (c) { byKey[c.k] = c; });
    var currency = root.getAttribute('data-currency') || (window.Shopify && Shopify.currency && Shopify.currency.active) || 'USD';
    var info = {
      byKey: byKey,
      step: currencyStep(currency),
      fmt: moneyFormatter((root.querySelector('[data-gbk-money]') || {}).textContent, currency),
      p2: num(root.getAttribute('data-p2'), 0),
      p3: num(root.getAttribute('data-p3'), 0),
      fs: num(root.getAttribute('data-fs'), 0),
      gearId: num(root.getAttribute('data-gear-id'), 0),
      gearPrice: num(root.getAttribute('data-gear-price'), 0),
      gearValue: num(root.getAttribute('data-gear-value'), 0)
    };
    info.bos = bosKit(root, byKey, info); /* BOS:PRICE-TEST hook */
    if (cache) cache.set(root, info);
    return info;
  }

  function state(root) {
    var n = Math.min(3, Math.max(1, Math.floor(num(root.getAttribute('data-count'), 1))));
    var keys = String(root.getAttribute('data-colors') || 'red,blue,camo').split(',');
    return { n: n, keys: keys };
  }

  function calc(info, n, keys) {
    var pct = n >= 3 ? info.p3 : (n >= 2 ? info.p2 : 0);
    var total = 0, value = 0, i, c;
    for (i = 0; i < n; i += 1) {
      c = info.byKey[keys[i]];
      if (!c) return null;
      total += c.p - unitDiscount(c.p, pct, info.step) + info.gearPrice;
      value += Math.max(c.v, c.p) + info.gearValue;
    }
    return { total: total, value: value, save: value > total ? Math.floor((value - total) * 100 / value) : 0 };
  }

  function render(root) {
    var info = setup(root);
    var st = state(root);
    var n = st.n;
    var res = calc(info, n, st.keys);
    if (!res) return;

    root.querySelectorAll('[data-gbk-kids]').forEach(function (btn) {
      var k = num(btn.getAttribute('data-gbk-kids'), 1);
      var on = k === n;
      btn.classList.toggle('is-on', on);
      btn.setAttribute('aria-checked', on ? 'true' : 'false');
      var priceNode = btn.querySelector('[data-gbk-kid-price]');
      var r = calc(info, k, st.keys);
      if (priceNode && r) priceNode.textContent = info.fmt(r.total);
    });

    var pic = root.querySelector('[data-gbk-pic]');
    if (pic) pic.setAttribute('data-n', String(n));
    root.querySelectorAll('[data-gbk-slot]').forEach(function (img) {
      var slot = num(img.getAttribute('data-gbk-slot'), 0);
      var c = info.byKey[st.keys[slot]];
      if (c && img.getAttribute('src') !== c.img) img.setAttribute('src', c.img);
      img.hidden = slot >= n;
      img.alt = slot < n && c ? 'Raven Shellblaster ' + c.n : '';
    });

    root.querySelectorAll('[data-gbk-per]').forEach(function (badge) {
      badge.textContent = 'x' + num(badge.getAttribute('data-gbk-per'), 1) * n;
    });

    var name = root.querySelector('[data-gbk-name]');
    if (name) name.textContent = n + (n === 1 ? ' full kit' : ' full kits');
    var gets = root.querySelector('[data-gbk-gets]');
    if (gets) gets.textContent = n === 1 ? 'Your kit includes' : 'Your kits include';
    var total = root.querySelector('[data-gbk-total]');
    if (total) total.textContent = info.fmt(res.total);
    var value = root.querySelector('[data-gbk-value]');
    if (value) value.textContent = info.fmt(res.value);
    var save = root.querySelector('[data-gbk-save]');
    if (save) {
      save.textContent = 'SAVE ' + res.save + '%';
      save.hidden = res.save < 1;
    }
    var perKid = root.querySelector('[data-gbk-per-kid]');
    if (perKid) {
      perKid.textContent = info.fmt(Math.round(res.total / n)) + ' per kit';
      perKid.hidden = n < 2;
    }
    var ship = root.querySelector('[data-gbk-ship]');
    if (ship) ship.hidden = !(info.fs > 0 && res.total >= info.fs);

    root.querySelectorAll('[data-gbk-row]').forEach(function (row) {
      var idx = num(row.getAttribute('data-gbk-row'), 0);
      row.hidden = idx >= n;
      row.querySelectorAll('[data-gbk-color]').forEach(function (dot) {
        var on = dot.getAttribute('data-gbk-color') === st.keys[idx];
        dot.classList.toggle('is-on', on);
        dot.setAttribute('aria-checked', on ? 'true' : 'false');
      });
    });

    var add = root.querySelector('[data-gbk-add]');
    var addText = root.querySelector('[data-gbk-add-text]');
    if (add && addText && !add.disabled) addText.textContent = 'ADD KIT · ' + info.fmt(res.total);
  }

  function addToCart(root, button) {
    if (button.disabled) return;
    var info = setup(root);
    var st = state(root);
    var counts = {};
    var order = [];
    for (var i = 0; i < st.n; i += 1) {
      var c = info.byKey[st.keys[i]];
      if (!c) return;
      if (!counts[c.id]) { counts[c.id] = 0; order.push(c.id); }
      counts[c.id] += 1;
    }
    if (!info.gearId || !order.length) return;
    var items = order.map(function (id) { return { id: id, quantity: counts[id] }; });
    items.push({ id: info.gearId, quantity: st.n });

    var text = root.querySelector('[data-gbk-add-text]');
    button.disabled = true;
    button.classList.remove('is-error');
    if (text) text.textContent = 'ADDING…';

    var cart = window.GBCart;
    var drawer = document.querySelector('cart-drawer');
    var idle;
    try { idle = cart && typeof cart.whenIdle === 'function' ? cart.whenIdle() : null; } catch (error) { idle = null; }

    Promise.resolve(idle).catch(function () {}).then(function () {
      var form = new FormData();
      items.forEach(function (item, index) {
        form.append('items[' + index + '][id]', String(item.id));
        form.append('items[' + index + '][quantity]', String(item.quantity));
        form.append('items[' + index + '][properties][_gbbs]', 'kit-' + st.n + (st.n === 1 ? '-kid' : '-kids'));
        if (info.bos && info.bos.lines[item.id]) form.append('items[' + index + '][properties][_bos_exp]', info.bos.lines[item.id]); /* BOS:PRICE-TEST hook */
      });
      var sections = drawer && typeof drawer.getSectionsToRender === 'function'
        ? drawer.getSectionsToRender().map(function (s) { return s.id; })
        : ['cart-drawer', 'cart-icon-bubble'];
      form.append('sections', sections.join(','));
      form.append('sections_url', window.location.pathname);
      return fetch(root.getAttribute('data-cart-add-url') || '/cart/add', {
        method: 'POST',
        headers: { Accept: 'application/javascript', 'X-Requested-With': 'XMLHttpRequest' },
        body: form
      }).then(function (response) { return response.json(); });
    }).then(function (data) {
      if (!data || data.status) throw new Error((data && (data.description || data.message)) || 'Could not add this kit.');
      var publishFn = typeof window.publish === 'function' ? window.publish : null;
      var events = window.PUB_SUB_EVENTS;
      if (publishFn && events && events.cartUpdate) {
        try { publishFn(events.cartUpdate, { source: 'product-form', productVariantId: items[0].id, cartData: data }); } catch (error) {}
      }
      var painted = false;
      if (drawer && typeof drawer.renderContents === 'function') {
        try {
          drawer.classList.remove('is-empty');
          if (typeof drawer.setActiveElement === 'function') drawer.setActiveElement(button);
          drawer.renderContents(data);
          painted = true;
        } catch (error) {}
      }
      if (!painted && cart && typeof cart.applyDrawer === 'function' && data.sections) {
        try {
          if (cart.applyDrawer(data.sections) !== false && drawer && typeof drawer.open === 'function') {
            drawer.open();
            painted = true;
          }
        } catch (error) {}
      }
      if (!painted) window.location.href = root.getAttribute('data-cart-url') || '/cart';
      if (text) text.textContent = 'ADDED ✓';
      setTimeout(function () {
        button.disabled = false;
        render(root);
      }, 1400);
    }).catch(function (error) {
      button.disabled = false;
      button.classList.add('is-error');
      if (text) text.textContent = 'TRY AGAIN';
      if (window.console) console.warn('[gbk] kit add failed', error);
      if (cart && typeof cart.readCart === 'function') {
        try { Promise.resolve(cart.readCart(true)).catch(function () {}); } catch (readError) {}
      }
    });
  }

  document.addEventListener('click', function (event) {
    var target = event.target;
    if (!target || !target.closest) return;
    var root = target.closest('[data-gbk]');
    if (!root) return;
    var kid = target.closest('[data-gbk-kids]');
    if (kid) {
      root.setAttribute('data-count', kid.getAttribute('data-gbk-kids'));
      render(root);
      return;
    }
    var dot = target.closest('[data-gbk-color]');
    if (dot) {
      var row = dot.closest('[data-gbk-row]');
      var idx = row ? num(row.getAttribute('data-gbk-row'), 0) : 0;
      var keys = String(root.getAttribute('data-colors') || 'red,blue,camo').split(',');
      keys[idx] = dot.getAttribute('data-gbk-color');
      root.setAttribute('data-colors', keys.join(','));
      render(root);
      return;
    }
    var add = target.closest('[data-gbk-add]');
    if (add) addToCart(root, add);
  });

  function start() {
    document.querySelectorAll('[data-gbk]').forEach(render);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start, { once: true });
  else start();
  window.GBKits = { render: render };
})();
